import { type PropsWithChildren } from "react";

import { useShellLayout } from "../context";
import { LAYOUT_CONFIG } from "../defaults";
import { useIsResizable } from "../ShellBody/ResizableContext";
import { ConversationPanelFrame } from "./ConversationPanelFrame";

interface RootProps {
  "aria-label": string;
  resizeAriaLabel: string;
}

export const Root = ({
  children,
  "aria-label": ariaLabel,
  resizeAriaLabel,
}: Readonly<PropsWithChildren<RootProps>>) => {
  const {
    conversationPanelState,
    conversationPanelWidth,
    onConversationPanelWidthChange,
  } = useShellLayout();
  const isResizable = useIsResizable();

  return (
    <ConversationPanelFrame
      aria-label={ariaLabel}
      resizeAriaLabel={resizeAriaLabel}
      data-testid="circle-ai-shell-conversation-panel"
      side="left"
      isResizable={isResizable}
      panelState={conversationPanelState}
      storedWidth={conversationPanelWidth}
      onWidthChange={onConversationPanelWidthChange}
      minWidth={LAYOUT_CONFIG.conversationPanel.minWidth}
      maxWidth={LAYOUT_CONFIG.conversationPanel.maxWidth}
    >
      {children}
    </ConversationPanelFrame>
  );
};

Root.displayName = "CircleAIAppShell.Layout.ConversationPanel";
